export default __webpack_public_path__ + "static/media/video-icon.c2bcd262.svg";